export default {
  subtitle: "Les clés authentifient les requêtes vers l'API Partenaire. Envoyez-les dans l'en-tête x-api-key.",
  never_used: 'Jamais utilisée',
  revoke_confirm: "Révoquer cette clé ? Les requêtes qui l'utilisent cesseront de fonctionner immédiatement.",
  columns: {
    name: 'Nom',
    key: 'Clé',
    status: 'Statut',
    last_used_at: 'Dernière utilisation',
    created_at: 'Créée le',
  },
  statuses: {
    active: 'Active',
    revoked: 'Révoquée',
  },
  buttons: {
    create: 'Créer une clé',
    revoke: 'Révoquer',
  },
  toasts: {
    load_error: 'Impossible de charger les clés API.',
    error: "Une erreur s'est produite. Veuillez réessayer.",
    revoked: 'Clé API révoquée.',
  },
};
